import { defaultChildren } from '@/components/combined-predict/components/CombinedPredictTable/utils/mappedGroupBuilders'

const getToddsModelColumnGroups = () => defaultChildren

export { getToddsModelColumnGroups }
